<template>
  <InputField
    v-bind="{
      labelClasses,
      helperClasses,
      errorMessageClasses,
      label,
      id,
      helper,
      error,
    }"
    class="inline-flex items-baseline"
    style="vertical-align: baseline"
  >
    <input
      ref="amountInput"
      v-model="localValue"
      :id="id"
      type="text"
      inputmode="decimal"
      :placeholder="placeholder"
      class="text-[2.25rem] md:text-[3.25rem] lg:text-[3.75rem] leading-[2.5rem] md:leading-[3.5rem] lg:leading-[4rem] font-black placeholder:text-[#A5A4A3] tracking-[-1.08px]"
      :class="[inputClasses || 'text-[#554638]', errorClasses, disabledClasses]"
      :style="{
        backgroundColor: '#F6F4F0 !important',
      }"
      @click="handleClick"
      @focus="handleFocus"
      @blur="$emit('blur')"
      @input="$emit('input', $event)"
      @keydown="$emit('keydown', $event)"
      @paste="$emit('paste', $event)"
      v-bind="$attrs"
    />
  </InputField>
</template>

<script>
import InputField from '@/mixins/InputField';
import HasLocalValue from '@/mixins/HasLocalValue';
import HasInputClassProps from '@/mixins/HasInputClassProps';
import { IonInput } from '@ionic/vue';
import { Keyboard } from '@capacitor/keyboard';

export default {
  components: {
    IonInput,
  },

  mixins: [HasLocalValue, InputField, HasInputClassProps],

  props: {
    inputClasses: {
      type: [String, Object, Array],
      default: null,
    },
    disabledClasses: {
      type: String,
      default: 'disabled:bg-[#F0F2F4]',
    },
    placeholder: {
      type: Number,
    },
  },

  methods: {
    async showKeyboard() {
      try {
        await Keyboard.show();
      } catch (err) {
        if (process.env.NODE_ENV === 'development') {
          console.warn('Keyboard.show() only works on native device');
        }
      }
    },

    async handleFocus() {
      await this.showKeyboard();
    },

    async handleClick(event) {
      if (this.$refs.amountInput) {
        this.$refs.amountInput.focus();
        await this.showKeyboard();
      }
      this.$emit('click', event);
    },
  },
};
</script>
